import {
    Component,
    h,
    Host,
    Prop,
} from '@stencil/core';

@Component({
    tag: 'portal-divider',
    styleUrl: 'portal-divider.scss',
    shadow: true,
})
export class PortalDivider {

    /**
   * divider type. Default is vertical
   * v: vertical
   * h: horizontal
   */
    @Prop() type: 'vertical' | 'horizontal' = 'vertical';

    /**
     * Margin size on both sides of the divider. Default is xxxl (16px)
     */
    @Prop() marginSize: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl' = 'xxxl';

    /**
     * Margin size on both sides of the divider (horizontal). Default is sm (4px)
     */
    @Prop() horizontalMarginSize: 'h-xs' | 'h-sm' | 'h-md' | 'h-lg' | 'h-xl' | 'h-xxl' | 'h-xxxl' = 'h-sm';

    /**
     * Should apply margin both vertically and horizontally
     */
    @Prop() bothMarginSize = false;

    /**
     * Should calculate width based on margins
     */
    @Prop() ignoreWidthMargins = true;

    render() {
        const isVertical = !this.type || this.type === 'vertical';
        const classes = {
            'divider': true,
            'horizontal-bar': this.type === 'horizontal',
            'vertical-bar': isVertical,
            'ignore-width-margins': this.ignoreWidthMargins,
            [this.marginSize]: isVertical || this.bothMarginSize,
            [this.horizontalMarginSize]: !isVertical || this.bothMarginSize,
        };

        return (
            <Host>
                <div class={classes}></div>
            </Host>
        );
    }
}
